import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ReportsIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.reportsIcon}`}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 22 25'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            clipRule='evenodd'
            d='M5.74992 0.50007H6.16849C7.13749 0.50007 7.99693 1.11961 8.30371 2.03837L8.36971 2.2371C8.47168 2.54376 8.75823 2.75006 9.0814 2.75006H19.25C20.4928 2.75006 21.5 3.75726 21.5 5.00005V16.25C21.5 17.4928 20.4928 18.5 19.25 18.5H2.75012C2.15304 18.5 1.58079 18.2631 1.15936 17.8408C0.737074 17.4193 0.5 16.847 0.5 16.25V2.74999C0.5 1.50721 1.50733 0.5 2.75012 0.5L5.74992 0.50007ZM2.75002 2C2.33593 2 1.99999 2.33607 1.99999 2.75003V16.2501C1.99999 16.4488 2.07877 16.6401 2.21969 16.7803C2.36 16.9213 2.55118 17.0001 2.75002 17.0001H19.2499C19.664 17.0001 19.9999 16.664 19.9999 16.25V5.00008C19.9999 4.58612 19.664 4.25006 19.2499 4.25006H9.0813C8.1123 4.25006 7.25287 3.63065 6.94608 2.71189L6.88009 2.51315C6.77811 2.20636 6.49169 2.00007 6.16839 2.00007L2.75002 2ZM5.00001 12.4998C4.58592 12.4998 4.24999 12.1639 4.24999 11.7499C4.24999 11.3358 4.58592 10.9999 5.00001 10.9999H17.0001C17.4141 10.9999 17.7501 11.3358 17.7501 11.7499C17.7501 12.1639 17.4141 12.4998 17.0001 12.4998H5.00001Z'
            fill='currentColor'
            fillRule='evenodd'
        />
    </svg>
);

export default ReportsIcon;
